import {ActionTypes} from "../../constants/actionTypes";

const initialState = {
  personas: {},
  ctasBancarias: [],
};

export const newInvestorFormReducer = (
  state = initialState,
  {type, payload}
) => {
  switch (type) {
    case ActionTypes.SET_NEWINVESTORFORM_INVERSIONISTA:
      return {...state, personas: payload};
    case ActionTypes.SET_NEWINVESTORFORM_CTASBANCARIAS:
      return {...state, ctasBancarias: payload};
    case ActionTypes.SET_NEWINVESTORFORM_RUT:
      return {...state, rut: payload};
    case ActionTypes.SET_NEWINVESTORFORM_NOMBRE:
      return {...state, nombre: payload};
    case ActionTypes.SET_NEWINVESTORFORM_APELLIDO_PATERNO:
      return {...state, apellido_paterno: payload};
    case ActionTypes.SET_NEWINVESTORFORM_APELLIDO_MATERNO:
      return {...state, apellido_materno: payload};
    case ActionTypes.SET_NEWINVESTORFORM_GENERO:
      return {...state, genero: payload};
    case ActionTypes.SET_NEWINVESTORFORM_DIRECCION:
      return {...state, direccion: payload};

    default:
      return state;
  }
};
